import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { ReactionResultDTO } from '@nora-monorepo/nora-api-client';
import { useApiStore } from '@nora-monorepo/ui-shared';

export const useReactionsModalStore = defineStore('reactionsModalStore', () => {
  const isLoading = ref(true);
  const reactions = ref<ReactionResultDTO[]>([]);
  const api = useApiStore();

  async function fetchReactionsData(messageId: string, conversationId: string): Promise<void> {
    isLoading.value = true;

    const result = await api.unwrap(
      api.conversationMessage.getMessageReactions({
        messageId,
        conversationId,
      }),
    );

    isLoading.value = false;
    if (!result.data) {
      reactions.value = [];
      return;
    }

    reactions.value = result.data;
  }

  function reset(): void {
    isLoading.value = false;
    reactions.value = [];
  }

  return {
    isLoading,
    reactions,

    fetchReactionsData,
    reset,
  };
});
